var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  opacity: .5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 6.702h8.727v1.636H0V6.702zm0-3.273h10.91v1.636H0V3.43zM0 .156h12v1.637H0V.156z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 9.974h9.818v1.637H0z"
}))));
export default __webpack_public_path__ + "teg/media/list.7a26922a.svg";
export { SvgComponent as ReactComponent };